import { render, staticRenderFns } from "./NormalLayout.vue?vue&type=template&id=0a425014&"
import script from "./NormalLayout.vue?vue&type=script&lang=js&"
export * from "./NormalLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports